/* ============================================================================
   Color Teleprompter — lisäosa kaupan konversiopohjaan
   ----------------------------------------------------------------------------
   TÄMÄ TIEDOSTO ON PELKKÄ LISÄYS. Se ei kajoa teeman omaan JavaScriptiin,
   ei jQueryyn, ei ajax-koriin, ei mihinkään olemassa olevaan tapahtuma-
   kuuntelijaan. Kaikki mitä täällä tehdään kohdistuu elementteihin joilla on
   `data-ct-*`-attribuutti — eikä niitä ole missään muualla teemassa.

   Jos tämän tiedoston poistaa, teema toimii täsmälleen kuten ennenkin.

   Kolme sääntöä joita ei rikota:

   1. Väritys tulee palvelimelta. Liquid on jo merkinnyt sanat luokkiinsa, joten
      oikeat värit ovat ruudulla ensimmäisessä maalauksessa. Jos väritys
      tehtäisiin täällä, kävijä näkisi ensin harmaan tekstin ja sitten
      välähdyksen — demo joka näyttää hitaammalta kuin tuote on.

   2. Vain `transform` liikkuu. Ei `top`, ei `scrollTop`, ei asettelun luentaa
      kehyksen sisällä. Kompositoija hoitaa liikkeen, prosessori pysyy vapaana.

   3. `prefers-reduced-motion` pysäyttää kokonaan.
   ========================================================================== */
(function () {
  'use strict';

  var SPEED = 0.62; // px / 16 ms

  function initPrompter(root) {
    if (root.getAttribute('data-ct-ready') === '1') return;
    root.setAttribute('data-ct-ready', '1');

    var view = root.querySelector('[data-ct-view]');
    var track = root.querySelector('[data-ct-track]');
    var btn = root.querySelector('[data-ct-play]');
    if (!view || !track) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var offset = 0;
    var loopAt = 0;
    var running = false;
    var onScreen = true;
    var raf = null;
    var last = 0;

    /* Sisältö kahdennetaan kerran, jotta silmukka on saumaton: kun ensimmäinen
       kappale on valunut ylös, toinen on jo paikallaan eikä mitään nykäistä
       takaisin alkuun. Kopio on aria-hidden, jottei ruudunlukija lue samaa
       tekstiä kahdesti. */
    function duplicate() {
      if (track.getAttribute('data-ct-doubled') === '1') return;
      loopAt = track.scrollHeight;
      if (!loopAt) return;
      var wrap = document.createElement('div');
      wrap.setAttribute('aria-hidden', 'true');
      var kids = track.children;
      for (var i = 0; i < kids.length; i++) wrap.appendChild(kids[i].cloneNode(true));
      track.appendChild(wrap);
      track.setAttribute('data-ct-doubled', '1');
    }

    function frame(now) {
      if (!running) return;
      var dt = last ? Math.min(now - last, 48) : 16;
      last = now;
      offset += SPEED * (dt / 16);
      if (loopAt && offset >= loopAt) offset -= loopAt;
      track.style.transform = 'translate3d(0,' + -offset + 'px,0)';
      raf = window.requestAnimationFrame(frame);
    }

    function play() {
      if (running || reduced.matches || !onScreen) return;
      running = true;
      last = 0;
      raf = window.requestAnimationFrame(frame);
      if (btn) { btn.textContent = btn.getAttribute('data-pause') || 'Pysäytä'; btn.setAttribute('aria-pressed', 'true'); }
    }

    function pause() {
      running = false;
      if (raf) window.cancelAnimationFrame(raf);
      raf = null;
      if (btn) { btn.textContent = btn.getAttribute('data-play') || 'Toista'; btn.setAttribute('aria-pressed', 'false'); }
    }

    duplicate();

    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () { running ? pause() : play(); });
    }

    // Hiiri päälle pysäyttää: liikkuva teksti lukemisen aikana on sama ongelma
    // jonka tuote ratkaisee.
    view.addEventListener('mouseenter', pause);
    view.addEventListener('mouseleave', play);

    document.addEventListener('visibilitychange', function () {
      document.hidden ? pause() : play();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          onScreen = entries[i].isIntersecting;
          onScreen ? play() : pause();
        }
      }, { threshold: 0.15 }).observe(root);
    }

    if (reduced.matches) pause(); else play();
  }

  /* --- Kopioinnin esto lukituilla alueilla --------------------------------
     Varsinainen suoja on rakenteessa eikä tässä: sanaluokkien tunnistus ajaa
     palvelimella sovelluksessa, eikä teemassa ole algoritmia jota lukea.
     Tämä estää helpon reitin — maalaa, kopioi, liitä muualle värjättynä. */
  function initCopyGuard() {
    // Kentat joihin kirjoitetaan on jatettava rauhaan: ilman tata hakuun tai
    // uutiskirjeeseen ei voisi liittaa mitaan, ja se rikkoisi konversion.
    function isField(el) {
      if (!el || !el.closest) return false;
      return !!el.closest('input, textarea, select, [contenteditable]');
    }

    function locked(node) {
      var el = node && node.nodeType === 1 ? node : (node && node.parentElement);
      if (!el) return false;
      if (isField(el)) return false;
      // Koko sivu on suojattu, ei vain promptteri. Kris: "koitetaan
      // minimoida kopiointi riski".
      return true;
    }

    document.addEventListener('copy', function (e) {
      var sel = window.getSelection();
      if (!sel || !sel.rangeCount) return;
      if (!locked(sel.getRangeAt(0).commonAncestorContainer)) return;
      e.preventDefault();
      try {
        e.clipboardData.setData('text/plain', document.title + ' — ' + window.location.origin);
      } catch (err) {}
    });

    document.addEventListener('cut', function (e) {
      var sel = window.getSelection();
      if (sel && sel.rangeCount && locked(sel.getRangeAt(0).commonAncestorContainer)) e.preventDefault();
    });

    document.addEventListener('dragstart', function (e) {
      if (locked(e.target)) e.preventDefault();
    });

    document.addEventListener('contextmenu', function (e) {
      if (isField(e.target)) return;
      e.preventDefault();
    });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-ct-prompter]');
    for (var i = 0; i < nodes.length; i++) initPrompter(nodes[i]);
    initCopyGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
